import { useMutation, useQueryClient } from '@tanstack/react-query'
import { api } from '@/lib/api'
import { meQueryKey } from '@/lib/useMe'

export interface EmergencyStatusResponse {
  active: boolean
  activated_at: string | null
}

type EmergencyAction = 'activate' | 'deactivate'

/**
 * Toggle für Emergency-Mode. Invalidiert ['me'] bei Success →
 * Dashboard-Banner re-rendert automatisch via useMe().
 */
export function useEmergencyToggle() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (action: EmergencyAction) => {
      const response = await api.post<EmergencyStatusResponse>(`/emergency/${action}`)
      return response.data
    },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: meQueryKey }),
  })
}
